import React from 'react';
import { HiChevronDown, HiCheck } from 'react-icons/hi';
import PopoverMenu from './PopoverMenu';
import { ROW_STATUS_LABEL, statusTone } from '../utils/requestGroups';

// The approver's per-asset decision control. The control IS the asset's
// status: its face shows the current decision as a dot + word in the status
// colour; opening it shows the three decisions (same card style as the
// download menu) with the current one checked. Picking a different one
// reports it through `onChange(value)` — values are the row vocabulary
// (OPEN / APPROVED / REJECTED); picking the current one does nothing.
const HEADING = 'Change decision';
const DECISIONS = [
    { value: 'OPEN', hint: 'Awaiting a decision' },
    { value: 'APPROVED', hint: 'The requester can download' },
    { value: 'REJECTED', hint: 'The requester sees the reason' },
];

export default function DecisionMenu({ status, onChange, disabled = false }) {
    const items = DECISIONS.map((d) => ({
        key: d.value,
        role: 'menuitemradio',
        checked: d.value === status,
        onSelect: () => { if (d.value !== status) onChange(d.value); },
        children: (
            <>
                <span className={`tone-dot tone-dot--${statusTone(d.value)}`} />
                <span className="popover-menu__item-text">
                    <span className="popover-menu__item-name">{ROW_STATUS_LABEL[d.value]}</span>
                    <span className="popover-menu__item-meta">{d.hint}</span>
                </span>
                {d.value === status && <HiCheck size={16} className="popover-menu__check" />}
            </>
        ),
    }));

    return (
        <PopoverMenu heading={HEADING} width={230} items={items}
            renderTrigger={({ ref, open, toggle, onKeyDown }) => (
                <button ref={ref} type="button" className={`decision decision--${statusTone(status)}`} disabled={disabled}
                    aria-haspopup="menu" aria-expanded={open} title="Change the decision for this asset"
                    aria-label={`${ROW_STATUS_LABEL[status] || status} — change the decision for this asset`}
                    onClick={toggle} onKeyDown={onKeyDown}>
                    <span className={`tone-dot tone-dot--${statusTone(status)}`} />
                    <span className="decision__label">{ROW_STATUS_LABEL[status] || status}</span>
                    <HiChevronDown size={12} className="decision__caret" />
                </button>
            )} />
    );
}
